import React, { useState,useContext } from "react";
import { ArrowLeft } from "lucide-react";
import { Tabs, Select, Table, Modal, message, Input, Button } from "antd";
import {
  searchSecondLevelSpecialLeaves,
  updateSecondLevelApproval,
  searchAuthorizedNoPayLeaves,
  updateAuthorizedNoPayApproval,
} from "../../service/leavesEmployeeApiService";
import AddAuthorizedNoPayLeave from "../../core/modals/hrm/AddAuthorizedNoPayLeave";
import { PlusCircle } from "react-feather";
import { UserContext } from "../../context/userContext"; // Adjust path as needed

const { TabPane } = Tabs;
const { Option } = Select;

const SecondLevelSpecialLeave = () => {
  const [activeTab, setActiveTab] = useState("specialLeaves");
  const { user } = useContext(UserContext); 
  const [dataSource, setDataSource] = useState({
    specialLeaves: [],
    authorizedNoPayLeaves: [],
  });
  const [filters, setFilters] = useState({
    epf_number: "",
    branch: null,
    name: null,
    startDate: null,
    endDate: null,
    status: null,
    secondLevelStatus: null,
  });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  const [pageSizeModalVisible, setPageSizeModalVisible] = useState(false);
  const [tempPageSize, setTempPageSize] = useState(pagination.pageSize);
  const [loading, setLoading] = useState(false);
  const [approvalModalVisible, setApprovalModalVisible] = useState(false);
  const [selectedLeaveId, setSelectedLeaveId] = useState(null);
  const [approvalStatus, setApprovalStatus] = useState(null);
  const [addModalVisible, setAddModalVisible] = useState(false);

  const branchOptions = [
      { value: "wattala", label: "Wattala" },
      { value: "negombo", label: "Negombo" },
      { value: "kaduwela", label: "Kaduwela" },
      { value: "kiribathgoda", label: "Kiribathgoda" },
      { value: "kandana", label: "Kandana" },
      { value: "delgoda", label: "Delgoda" },
      { value: "lsu", label: "Wattala LSU" },
      { value: "cityschool", label: "City School - Negombo" }
  ];

  const statusOptions = [
    { value: null, label: "All Statuses" },
    { value: "approve", label: "Approved" },
    { value: "reject", label: "Rejected" },
    { value: "pending", label: "Pending" },
  ];

  const secondLevelStatusOptions = [
    { value: null, label: "All Second-Level Statuses" },
    { value: "approve", label: "Approved" },
    { value: "reject", label: "Rejected" },
    { value: "pending", label: "Pending" },
  ];

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
  };

  const handlePageSizeChange = () => {
    setPagination((prev) => ({ ...prev, pageSize: tempPageSize, current: 1 }));
    setPageSizeModalVisible(false);
  };

  const searchSpecialLeaves = async () => {
    try {
      setLoading(true);
      const params = {
        epf_number: filters.epf_number || undefined,
        branch: filters.branch || undefined,
        name: filters.name || undefined,
        startDate: filters.startDate || undefined,
        endDate: filters.endDate || undefined,
        status: filters.status || undefined,
        secondLevelStatus: filters.secondLevelStatus || undefined,
        userId: localStorage.getItem("userId") || undefined,
      };
      console.log("Search params (Special Leaves):", params);
      const response = await searchSecondLevelSpecialLeaves(params);
      console.log("Search response (Special Leaves):", response);
      const mappedData = Array.isArray(response.data)
        ? response.data
            .filter((item) => item.employee?.full_name && item.employee.full_name !== "-")
            .map((item) => ({
              id: item._id,
              epf_number: item.employee?.epf_number || "-",
              name: item.employee?.full_name || "-",
              branch: item.employee?.branch || "-",
              department: item.department?.departmentName || "-",
              leaveType: item.leaveType?.name || "-",
              date: item.startDate || "-",
              reason: item.reason || "-",
              approval: item.approval === true ? "Approved" : item.approval === false ? "Rejected" : "Pending",
              secondLevelApproval:
                item.secondLevelApproval === true
                  ? "Approved"
                  : item.secondLevelApproval === false
                  ? "Rejected"
                  : "Pending",
            }))
        : [];
      setDataSource((prev) => ({ ...prev, specialLeaves: mappedData }));
      setPagination((prev) => ({
        ...prev,
        total: mappedData.length,
        current: 1,
      }));
      setLoading(false);
      if (mappedData.length === 0) {
        message.warning("No special leave records found for the selected filters.");
      }
    } catch (error) {
      console.error("Error searching special leaves:", error);
      setLoading(false);
      message.error(error.message);
    }
  };

 const searchAuthorizedNoPayLeavesTab = async () => {
    try {
      setLoading(true);
      const userId = user?._id || JSON.parse(localStorage.getItem("user"))?.data?._id;
      if (!userId) {
        throw new Error("User ID is not available. Please log in again.");
      }
      const params = {
        epf_number: filters.epf_number || undefined,
        branch: filters.branch || undefined,
        name: filters.name || undefined,
        startDate: filters.startDate || undefined,
        endDate: filters.endDate || undefined,
        status: filters.status || undefined,
        userId: userId, // Use userId from context or localStorage
      };
      console.log("Search params (Authorized No Pay Leaves):", params);
      const response = await searchAuthorizedNoPayLeaves(params);
      console.log("Search response (Authorized No Pay Leaves):", response);
      const mappedData = Array.isArray(response.data)
        ? response.data
            .filter((item) => item.employee?.full_name && item.employee.full_name !== "-")
            .map((item) => ({
              id: item._id,
              epf_number: item.employee?.epf_number || "-",
              name: item.employee?.full_name || "-",
              branch: item.employee?.branch || "-",
              department: item.department?.departmentName || "-",
              startDate: item.startDate || "-",
              endDate: item.endDate || "-",
              reason: item.reason || "-",
              approval: item.approval === true ? "Approved" : item.approval === false ? "Rejected" : "Pending",
            }))
        : [];
      setDataSource((prev) => ({ ...prev, authorizedNoPayLeaves: mappedData }));
      setPagination((prev) => ({
        ...prev,
        total: mappedData.length,
        current: 1,
      }));
      setLoading(false);
      if (mappedData.length === 0) {
        message.warning("No Authorized No Pay Leave records found for the selected filters.");
      }
    } catch (error) {
      console.error("Error searching Authorized No Pay Leaves:", error.response?.data || error.message);
      setLoading(false);
      const errorMessage = error.response?.data?.message || error.message;
      message.error(errorMessage);
      if (errorMessage.includes("userId is required") || errorMessage.includes("User ID is not available")) {
        message.warning("Please log in again to refresh your session.");
      }
    }
  };

  const handleApprovalClick = (leaveId, currentStatus, tab) => {
    setSelectedLeaveId(leaveId);
    setApprovalStatus(
      currentStatus === "Approved" ? true : currentStatus === "Rejected" ? false : null
    );
    setApprovalModalVisible(true);
    setActiveTab(tab); // Store the active tab for approval submission
  };

  const handleApprovalSubmit = async () => {
    try {
      setLoading(true);
      if (activeTab === "specialLeaves") {
        await updateSecondLevelApproval(selectedLeaveId, approvalStatus);
        message.success("Second-level approval status updated successfully!");
        searchSpecialLeaves(); // Refresh Special Leaves
      } else if (activeTab === "authorizedNoPayLeaves") {
        await updateAuthorizedNoPayApproval(selectedLeaveId, approvalStatus);
        message.success("Authorized No Pay Leave approval status updated successfully!");
        searchAuthorizedNoPayLeavesTab(); // Refresh Authorized No Pay Leaves
      }
      setApprovalModalVisible(false);
    } catch (error) {
      console.error("Error updating approval:", error);
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAddModalSuccess = () => {
    setActiveTab("authorizedNoPayLeaves");
    searchAuthorizedNoPayLeavesTab(); // Refresh Authorized No Pay Leaves tab
  };

  const columns = {
    specialLeaves: [
      { title: "EPF No", dataIndex: "epf_number", render: (text) => text || "-" },
      { title: "Name", dataIndex: "name", render: (text) => text || "-" },
      { title: "Branch", dataIndex: "branch", render: (text) => text || "-" },
      { title: "Department", dataIndex: "department", render: (text) => text || "-" },
      { title: "Date", dataIndex: "date", render: (text) => text || "-" },
      { title: "Reason", dataIndex: "reason", render: (text) => text || "-" },
      {
        title: "First-Level Approval",
        dataIndex: "approval",
        render: (text) => text || "Pending",
      },
      {
        title: "Second-Level Approval",
        dataIndex: "secondLevelApproval",
        render: (text, record) => (
          <Button
            type={text === "Pending" ? "primary" : "default"}
            onClick={() => handleApprovalClick(record.id, text, "specialLeaves")}
          >
            {text || "Pending"}
          </Button>
        ),
      },
    ],
    authorizedNoPayLeaves: [
      { title: "EPF No", dataIndex: "epf_number", render: (text) => text || "-" },
      { title: "Name", dataIndex: "name", render: (text) => text || "-" },
      { title: "Branch", dataIndex: "branch", render: (text) => text || "-" },
  { 
    title: "Start Date", 
    dataIndex: "startDate", 
    render: (text) => text ? new Date(text).toISOString().split("T")[0] : "-" 
  },
  { 
    title: "End Date", 
    dataIndex: "endDate", 
    render: (text) => text ? new Date(text).toISOString().split("T")[0] : "-" 
  },
      { title: "Reason", dataIndex: "reason", render: (text) => text || "-" },
      // {
      //   title: "Approval",
      //   dataIndex: "approval",
      //   render: (text, record) => (
      //     <Button
      //       type={text === "Pending" ? "primary" : "default"}
      //       onClick={() => handleApprovalClick(record.id, text, "authorizedNoPayLeaves")}
      //     >
      //       {text || "Pending"}
      //     </Button>
      //   ),
      // },
    ],
  };

  return (
    <div className="page-wrapper-lt">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="header-leave-container">
              <div>
                <ArrowLeft size={32} />
              </div>
              <div className="page-title">
                <h4>Second-Level Approval</h4>
                <h6></h6>
              </div>
            </div>
            <div className="page-btn" style={{display:"none"}}>
              <button
                className="btn btn-primary"
                onClick={() => setAddModalVisible(true)}
              >
                                  <PlusCircle className="me-2" />
                
               NoPay
              </button>
            </div>
          </div>
        </div>
        <div className="card table-list-card-grid">
          <div className="card-body" style={{ maxWidth: "100%", marginRight: "20px" }}>
            <div
              className="container mt-3"
              style={{ maxWidth: "100%", marginLeft: "20px", marginRight: "40px" }}
            >
              <div className="row d-flex flex-wrap align-items-start justify-content-between">
                <div className="col-12 col-md-2 text-start">
                  <label className="form-label">EPF No</label>
                  <Input
                    value={filters.epf_number}
                    onChange={(e) => handleFilterChange("epf_number", e.target.value)}
                    className="form-control"
                    style={{ width: "100%", height: "38px" }}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">Branch</label>
                  <Select
                    value={filters.branch}
                    options={branchOptions}
                    className="select"
                    placeholder="Select Branch"
                    onChange={(value) => handleFilterChange("branch", value)}
                    allowClear
                    style={{ width: "100%", height: "38px" }}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">Name</label>
                  <Input
                    value={filters.name}
                    onChange={(e) => handleFilterChange("name", e.target.value)}
                    className="form-control"
                    style={{ width: "100%", height: "38px" }}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">Start Date</label>
                  <Input
                    type="date"
                    value={filters.startDate}
                    onChange={(e) => handleFilterChange("startDate", e.target.value)}
                    className="form-control"
                    style={{ width: "100%", height: "38px" }}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">End Date</label>
                  <Input
                    type="date"
                    value={filters.endDate}
                    onChange={(e) => handleFilterChange("endDate", e.target.value)}
                    className="form-control"
                    style={{ width: "100%", height: "38px" }}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">Approval</label>
                  <Select
                    value={filters.status}
                    options={statusOptions}
                    className="select"
                    placeholder="Select Status"
                    onChange={(value) => handleFilterChange("status", value)}
                    allowClear
                    style={{ width: "100%", height: "38px" }}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start" style={{ display: "none" }}>
                  <label className="form-label">Second-Level Status</label>
                  <Select
                    value={filters.secondLevelStatus}
                    options={secondLevelStatusOptions}
                    className="select"
                    placeholder="Select Second-Level Status"
                    onChange={(value) => handleFilterChange("secondLevelStatus", value)}
                    allowClear
                    style={{ width: "100%", height: "38px" }}
                  />
                </div>
                <div className="col-12 col-md-1 mb-3 text-start">
                  <label className="form-label"> </label>
                  <button
                    disabled={loading}
                    className="btn btn-submit"
                    onClick={activeTab === "specialLeaves" ? searchSpecialLeaves : searchAuthorizedNoPayLeavesTab}
                    style={{ height: "38px", width: "100%" }}
                  >
                    {loading ? "Searching..." : "Search"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card table-list-card-grid">
          <div className="card-body pb-0">
            <Tabs
              activeKey={activeTab}
              onChange={(key) => {
                setActiveTab(key);
                setPagination((prev) => ({ ...prev, current: 1 }));
                if (key === "authorizedNoPayLeaves" && dataSource.authorizedNoPayLeaves.length === 0) {
                  searchAuthorizedNoPayLeavesTab();
                }
              }}
            >
              <TabPane tab="Special Leaves" key="specialLeaves">
                <Table
                  loading={loading}
                  columns={columns.specialLeaves}
                  dataSource={dataSource.specialLeaves}
                  rowKey={(record) => record.id}
                  className="custom-ant-table-grid"
                  pagination={{
                    current: pagination.current,
                    total: pagination.total,
                    pageSize: pagination.pageSize,
                    pageSizeOptions: ["5", "10", "20", "50"],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total) => `Total ${total} items`,
                    onShowSizeChange: (current, size) => {
                      setTempPageSize(size);
                      setPageSizeModalVisible(true);
                    },
                  }}
                  onChange={handleTableChange}
                />
              </TabPane>
              <div style={{display:"none"}}>
              <TabPane tab="Authorized No Pay Leaves" key="authorizedNoPayLeaves" >
                <Table
                  loading={loading}
                  columns={columns.authorizedNoPayLeaves}
                  dataSource={dataSource.authorizedNoPayLeaves}
                  rowKey={(record) => record.id}
                  className="custom-ant-table-grid"
                  pagination={{
                    current: pagination.current,
                    total: pagination.total,
                    pageSize: pagination.pageSize,
                    pageSizeOptions: ["5", "10", "20", "50"],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total) => `Total ${total} items`,
                    onShowSizeChange: (current, size) => {
                      setTempPageSize(size);
                      setPageSizeModalVisible(true);
                    },
                  }}
                  onChange={handleTableChange}
                />
              </TabPane></div>
            </Tabs>
          </div>
        </div>
      </div>
      <Modal
        title="Change Page Size"
        open={pageSizeModalVisible}
        onOk={handlePageSizeChange}
        onCancel={() => setPageSizeModalVisible(false)}
        footer={[
          <button
            key="cancel"
            className="btn btn-cancel"
            onClick={() => setPageSizeModalVisible(false)}
          >
            Cancel
          </button>,
          <button
            key="submit"
            className="btn btn-submit"
            onClick={handlePageSizeChange}
          >
            Apply
          </button>,
        ]}
      >
        <div className="form-group">
          <label>Items per page:</label>
          <Select
            style={{ width: "100%" }}
            value={tempPageSize}
            onChange={(value) => setTempPageSize(value)}
          >
            {[5, 10, 20, 50, 100].map((size) => (
              <Option key={size} value={size}>
                {size}
              </Option>
            ))}
          </Select>
        </div>
      </Modal>
      <Modal
        title="Update Approval Status"
        open={approvalModalVisible}
        onOk={handleApprovalSubmit}
        onCancel={() => setApprovalModalVisible(false)}
        footer={[
          <button
            key="cancel"
            className="btn btn-cancel"
            onClick={() => setApprovalModalVisible(false)}
          >
            Cancel
          </button>,
          <button
            key="submit"
            className="btn btn-submit"
            onClick={handleApprovalSubmit}
            disabled={loading}
          >
            {loading ? "Updating..." : "Update"}
          </button>,
        ]}
      >
        <div className="form-group">
          <label>Approval Status:</label>
          <Select
            style={{ width: "100%" }}
            value={approvalStatus}
            onChange={(value) => setApprovalStatus(value)}
          >
            <Option value={true}>Approve</Option>
            <Option value={false}>Reject</Option>
            <Option value={null}>Pending</Option>
          </Select>
        </div>
      </Modal>
      <Modal
        open={addModalVisible}
        onCancel={() => setAddModalVisible(false)}
        footer={null}
      >
        <AddAuthorizedNoPayLeave
          handleCancel={() => setAddModalVisible(false)}
          onSuccess={handleAddModalSuccess}
        />
      </Modal>
    </div>
  );
};

export default SecondLevelSpecialLeave;
